import { RequestDraft, RequestDraftToken } from "$src/application/projects/sub/drafts/commands/RequestDraft";
import { DraftPermission } from "$src/domain/projects/drafts/DraftPermission";
import { useMutation } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

export async function requestDraft(groupStoreId: number, projectId: number)
    : Promise<DraftPermission> {

    const query = container.resolve<RequestDraft>(RequestDraftToken);
    return query.execute(groupStoreId, projectId);
}

export function useRequestDraft() {
    return useMutation(
        ({ groupStoreId, projectId }: 
            { groupStoreId: number, projectId: number }
        ) => requestDraft(groupStoreId, projectId)
    );
}